module.exports = __webpack_public_path__ + "static/media/email_icon.818a0a0a.svg";